import { authConstants } from '../constant/auth.constants';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

let info = cookies.get('info');

export const initialState = {
    loggedIn: info ? true : false,
    info: info ? info : {},
    errorCode: '',
    successCode: ''
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case authConstants.LOGIN_REQUEST:
            return {
                loggingIn: true,
                info: action.info
            };

        case authConstants.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                info: action.info
            };

        case authConstants.LOGIN_FAILURE:
            return {
                loggedIn: false,
                errorCode: action.error,
                info: {}
            };

        case authConstants.LOGOUT:
            return {
                loggedIn: false,
                info: ''
            };

        case authConstants.CLEAR_ERROR:
            return {
                errorCode: ''
            };

        case authConstants.FORGOT_PASSWORD_FAILURE:
            return {
                errorCode: action.error
            };

        case authConstants.FORGOT_PASSWORD_SUCCESS:
            return {
                successCode: action.success
            };

        case authConstants.RESET_PASSWORD_SUCCESS:
            return {
                successCode: action.success
            };

        case authConstants.RESET_PASSWORD_FAILURE:
            return {
                errorCode: action.error
            };

        case authConstants.RESET_SECRETKEY_FAILURE:
            return {
                errorCode: action.error
            };

        case authConstants.CHANGE_PASSWORD_SUCCESS:
            return {
                successCode: action.success
            };

        case authConstants.CHANGE_PASSWORD_FAILURE:
            return {
                errorCode: action.error
            };
        default:
            return state;
    }
}
export default authReducer;
